import { render, staticRenderFns } from "./en_home.vue?vue&type=template&id=52914cb6&scoped=true&"
import script from "./en_home.vue?vue&type=script&lang=js&"
export * from "./en_home.vue?vue&type=script&lang=js&"
import style0 from "./en_home.vue?vue&type=style&index=0&id=52914cb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52914cb6",
  null
  
)

export default component.exports